import * as React from "react";
import { makeStyles, useTheme, Theme } from '@material-ui/core/styles';
import { IDefaultViewProps } from "./IDefaultViewProps";
import { Caption } from "../../atoms/views/Caption";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import { useTranslation } from 'react-i18next';



// All the incoming values
interface IProps {
    detail?: string
}

// Outgoing functions
interface IDispatch {

}

// Doelgroep
export interface IDoelgroep {
    id: string;
    naam: string;
}

// Actual Component
export type AllProps = IProps & IDispatch & IDefaultViewProps<IDoelgroep[]>;
export const Doelgroepen = (props: AllProps) => {
    const classes = useStyles(useTheme());
    const { t: tDatatypes } = useTranslation('datatypes');
    const label = props.label || tDatatypes('doelgroepenLabel') || "Doelgroepen";

    return (<Caption caption={label} loading={props.loading}>
        <List dense={true}>
            {props.value.map((doelgroep, index) => (
                <ListItem key={index}>
                    <ListItemText primary={`${index + 1}. ${doelgroep.naam}`} />
                </ListItem>
            ))}
            {props.detail && props.detail.length > 0 && (
                <ListItem>
                    <ListItemText primary={`${props.detail}`} />
                </ListItem>
            )}
        </List>
    </Caption>)
}

// CSS
const useStyles = makeStyles((theme: Theme) => ({ }));